export default function Pagination({
    page,
    totalPages,
    setPage,
}) {
    return (
        <div className="flex justify-center gap-3">

            <button
                disabled={page===1}
                onClick={()=>setPage(page-1)}
                className="px-4 py-2 rounded bg-gray-200"
            >
                Previous
            </button>

            <span>
                {page} / {totalPages}
            </span>

            <button
                disabled={page===totalPages}
                onClick={()=>setPage(page+1)}
                className="px-4 py-2 rounded bg-purple-600 text-white"
            >
                Next
            </button>

        </div>
    );
}